




















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import type { Lesson } from '@/models/lesson';
import type { PMLesson } from '@/models/pmlesson';
import LessonsList from '@/components/knowledge/lessons/LessonsList.vue';
import MoreInfoModal from '@/components/MoreInfoModal.vue';
import { countLessons } from '@/helpers/countLessons';

@Component({
    name: 'PreviewLessons',
    components: {
        MoreInfoModal,
        LessonsList,
    },
})
export default class PreviewLessons extends Vue {
    @Prop() private lessons: Lesson[] | PMLesson[];
    @Prop() private parentCheckBox: boolean;
    @Prop({ default: () => [] }) private checkedParentLesson: Lesson[];
    @Prop() private disableLesson: Lesson;

    private isLessonsListOpen: boolean = false;

    private moreInfoShowModalActive: boolean = false;
    private moreInfoModalInsight: string;
    private moreInfoModalContent: string;
    private moreInfoModalId: number;
    private lessonCount: number = 0;

    @Watch('lessons')
    private lessonsChange() {
        this.lessonCount = countLessons(this.lessons);
    }

    private initializeMoreInfoModal(lesson: Lesson) {
        this.moreInfoModalContent = lesson.more_info;
        this.moreInfoModalInsight = lesson.insight;
        this.moreInfoModalId = lesson.id;
        this.moreInfoShowModalActive = true;
    }
}
